'use client'

import { useMemo } from 'react'
import { useGetCmsCommunityLinksQuery } from 'core/query/yapi/hk-web/CmsCommunity/query'
import { useLocale } from 'core/components/Locale'
import HCNextLink from '@/components/HCNextLink'
import styles from './index.module.scss'

const FooterLink = ({ isShow = true }: { isShow: boolean }) => {
  const t = useLocale()

  const { data } = useGetCmsCommunityLinksQuery(undefined, {
    enabled: isShow,
  })

  const links = useMemo(() => {
    if (!data?.data) return []
    return data.data.data
  }, [data])

  if (!isShow) return null

  return (
    <div className={styles.footerLink}>
      <div className={styles.titleContainer}>
        <span>{`Hotcoin${t('nft_game_007')}`}</span>
      </div>
      <div className={styles.linkContainer}>
        {links.map((item) => (
          <div key={item.id} className={styles.linkItem}>
            <HCNextLink className={styles.link} href={item.linkWeb!}>
              {item.name}
            </HCNextLink>
          </div>
        ))}
      </div>
    </div>
  )
}

export default FooterLink
